{
  "toasts": {
    "error": {
      "addUser": "Unable to add user, something went wrong",
      "adoptionDateNotSet": "Failed to set adoption date",
      "avatar": "Failed to save image",
      "categoryNotCreated": "The category wasn't created, something went wrong",
      "categoryNotRemoved": "Failed to remove category",
      "copyFailed": "Failed to copy link",
      "diffSummaryFailed": "Failed to generate diff summary",
      "documentDownloaded": "Error downloading document",
      "projectNotArchived": "Failed to archive project",
      "editUser": "User didn't edit, something went wrong",
      "email": "The email was not found",
      "generic": "An unexpected error occurred, please try to reload the page",
      "incorectCurrentPass": "Incorrect current password",
      "incorectPass": "Incorrect email or password",
      "invalid2faCode": "Invalid verification code. Please try again.",
      "passNotReset": "Password reset error",
      "reorder": "Failed to reorder categories",
      "reorderDocuments": "Failed to reorder documents",
      "save": "Save error",
      "tierNotCreated": "The Tier wasn't created, something went wrong",
      "tierNotRemoved": "Failed to remove tier",
      "workflowNotMoved": "Failed to move workflow",
      "workflowNotCancelled": "Failed to cancel workflow"
    },
    "success": {
      "2faActivated": "Two factor authentication is activated.",
      "2faDisabled": "Two factor authentication is disabled.",
      "adoptionDateSet": "Adoption date set successfully",
      "categoryCreated": "Category created successfully",
      "categoryRemoved": "Category removed successfully",
      "categoryUpdated": "Category updated successfully",
      "projectArchived": "Project archived",
      "documentDownloaded": "Document downloaded successfully",
      "documentUpdated": "Document updated successfully",
      "keyCopied": "Key copied",
      "linkCopied": "Link copied to clipboard",
      "passUpdated": "Your password has been updated",
      "photoSaved": "Photo saved",
      "profileUpdated": "Profile updated",
      "readersInvited": "Reader invitations sent successfully",
      "reorder": "reordered successfully",
      "tagCreated": "\"{{tagName}}\" created and selected",
      "tierCreated": "Tier created successfully",
      "tierRemoved": "Tier removed successfully",
      "tierUpdated": "Tier updated successfully",
      "workflowCancelled": "Workflow cancelled successfully"
    },
    "warning": {
      "maxSize": "The maximum image size is 1 MB"
    },
    "info": {
      "cookieBanner": "We use a cookie to help us understand how users interact with our application.",
      "cookieHeader": "Cookie Settings",
      "noDiffSummaryAvailable": "No differences found between versions. Make changes to the document and try again.",
      "noDocumentsFound": "No documents found for the selected filters",
      "sessionExpired": "Session expired, please log in again"
    }
  }
}
